import { fetchApi } from '@/config/api'
import type { Campagne } from '@/types/promotion'

/**
 * Récupère les campagnes de promotion limitée disponibles pour un vendeur
 */
export async function getCampagnesByVendeur(
  idVendeur: number,
): Promise<Campagne[]> {
  const query = `
    query GetCampagnesByVendeur($id_vendeur: Int!) {
      campagnesByVendeur(id_vendeur: $id_vendeur) {
        id_campagne
        titre
        debut
        fin
        statut
        type_campagne
        nb_produits
        valeur_min
        valeur_max
      }
    }
  `

  const response = await fetchApi<{ campagnesByVendeur: Campagne[] }>(
    query,
    { id_vendeur: idVendeur },
  )
  return response.campagnesByVendeur
}

